/**
 * Load Decision Board actions from existing LIVE certified sources only.
 * Source: Ops Intelligence rule engine (FOUNDER-DASHBOARD-000006) — not AI.
 */

import { amazonConnectApi, type SellerConnection } from '../api/amazonconnect';
import { loadOpsIntelligence } from '../founder-dashboard/ops-intelligence/loadOpsIntelligence';
import { mapOpsItemToDecision } from './mapFromOps';
import type { CommandCenterModel } from './types';

export async function loadCommandCenterActions(opts: {
  connection: SellerConnection | null;
}): Promise<CommandCenterModel> {
  const conn = opts.connection;
  const ops = await loadOpsIntelligence({ connection: conn });

  const actions = ops.items.map((item) =>
    mapOpsItemToDecision(item, {
      sellerRef: ops.sellerRef ?? conn?.seller_ref,
      marketplace: conn?.marketplace_ids?.[0],
      connectionId: ops.connectionId,
    }),
  );

  return {
    loadedAt: ops.loadedAt || new Date().toISOString(),
    connectionId: ops.connectionId,
    sellerRef: ops.sellerRef ?? conn?.seller_ref,
    marketplace: conn?.marketplace_ids?.[0],
    actions,
    truncated: ops.truncated,
    error: ops.error,
    sourceNote:
      ops.sourceNote ||
      'LIVE MarketSync rule signals only. No AI. No invented actions.',
  };
}

export async function resolvePrimaryConnection(): Promise<{
  connection: SellerConnection | null;
  connections: SellerConnection[];
}> {
  try {
    const list = await amazonConnectApi.listConnections();
    const connections = Array.isArray(list) ? list : [];
    const active =
      connections.find(
        (c) =>
          c.status === 'approved' ||
          c.status === 'active' ||
          c.status === 'connected',
      ) ??
      connections[0] ??
      null;
    return { connection: active, connections };
  } catch {
    return { connection: null, connections: [] };
  }
}
